///<reference path='event.ts' />

module agi.expressions.event {
    export class EventBus extends EventDispatcher{
        private static instance:EventBus = null;

        constructor(){
            super();
            if(EventBus.instance)
                throw(new Error("Error: Multiple instances of a Singleton Class."))
        }

        public static getInstance():EventBus{
            if(EventBus.instance === null)
                EventBus.instance = new EventBus();

            return EventBus.instance;
        }
    }
}